import React from 'react';
import PropTypes from 'prop-types';
import ProductPrice from '../../ProductPrice';
import DefaultPicture from '../../../components/01_atoms/DefaultPicture';
import { hasDeleteButton } from '../../../utils/Gifts/basket';
import RemoveProductButton from '../../RemoveProductButton';
import Link from '../../Link';
import TruckThinIcon from '../../../public/static/icons/truck-thin.svg';

import s from './index.module.scss';

const SantaLetterBasketItem = ({ item, cardIndex }) => (
  <div className={s['santa-letter-basket-item']}>
    <div className={s['santa-letter-basket-item__product']}>
      {item.product && item.product.image && (
        <DefaultPicture {...item.product.image} className={s['santa-letter-basket-item__image']} />
      )}

      <div className={s['santa-letter-basket-item__details']}>
        <div className={s['santa-letter-basket-item__header']}>
          <h3 className={s['santa-letter-basket-item__title']}>
            {item.product.title}
            {item.name ? ` for ${item.name}` : ''}
          </h3>
          <div className={s['santa-letter-basket-item__price']}>
            <ProductPrice product={item.product} />
          </div>
        </div>

        <div className={s['santa-letter-basket-item__delivery-and-remove']}>
          <div className={s['santa-letter-basket-item__delivery']}>
            <TruckThinIcon /> Sent by post{' '}
            <span className={s['santa-letter-basket-item__north-pole']}>from North Pole</span>
          </div>
          {hasDeleteButton(item.product) && (
            <RemoveProductButton productId={item.product.id} indexes={[cardIndex]} />
          )}
        </div>
      </div>
    </div>
    <div className={s['santa-letter-basket-item__need-more-section']}>
      <div className={s['santa-letter-basket-item__need-more']}>
        <div className={s['santa-letter-basket-item__need-more-title']}>
          Got more little ones to surprise?
        </div>
        <Link href={item.product.url.url}>
          <a className={s['santa-letter-basket-item__need-more-link']}>
            Create another {item.product.title}
          </a>
        </Link>
      </div>
    </div>
  </div>
);

SantaLetterBasketItem.propTypes = {
  cardIndex: PropTypes.number.isRequired,
  item: PropTypes.shape({
    name: PropTypes.string.isRequired,
    product: PropTypes.shape({
      id: PropTypes.number,
      type: PropTypes.string,
      title: PropTypes.string,
      categoryIds: PropTypes.arrayOf(PropTypes.number),
      variantType: PropTypes.string,
      annotation: PropTypes.string,
      description: PropTypes.string,
      price: PropTypes.object,
      image: PropTypes.object,
      actionImage: PropTypes.object,
      actionDescription: PropTypes.string,
      giftsInBundle: PropTypes.arrayOf(PropTypes.object),
      url: PropTypes.shape({
        url: PropTypes.string.isRequired,
      }),
    }).isRequired,
  }).isRequired,
};

export default SantaLetterBasketItem;
